import { howToHelpService } from "../../services/api";

export interface HowToHelp {
  id: number;
  heading: string;
  text: string;
}

export interface HowToHelpFormatted {
  firstWord: string;
  heading: string;
  description: string;
}

let howToHelpList: HowToHelpFormatted[] = [
  {
    firstWord: "Вставай",
    heading: "на захист України поряд з нами",
    description: `На одного Бійця має припадати до 10 небойових побратимів та посестер, котрі забезпечують його бойову діяльність!\nТому ми шукаємо фахівців різного профілю. Дізнайся про наявні вакансії у наших рекрутерів!`,
  },
  {
    firstWord: "Приєднуйся",
    heading: "до наших соціальних мереж",
    description:
      "Підтримай нас вподобайками, коментарями та репостами! Кожна реакція допомагає нашому полку рости та розвиватися.\nДякуємо, що ти з нами!",
  },
  {
    firstWord: "Підтримуй",
    heading: "наші збори",
    description:
      "На жаль, наша ефективність та майстерність не завжди встигають за нашими можливостями. З твоєю підтримкою ми можемо нищити окупантів більше, точніше та яскравіше! Разом ми сильніші!",
  },
  {
    firstWord: "Придбай",
    heading: "наш мерч",
    description:
      "Кожна покупка мерча — це більше, ніж просто річ. Це внесок у зміцнення обороноздатності України. Це підтримка, яка допомагає нам рухатися далі, розвивати боєздатність і ставати сильнішими. Обираючи наш мерч, ти стаєш частиною нашої бойової родини",
  },
  {
    firstWord: "Допомагай",
    heading: "власною справою",
    description:
      "Можливо, ти маєш власне СТО чи друкарський верстат? Ти юрист або психолог? А можливо, у тебе багато підписників, і ти закриєш наш збір лише за кілька днів? Будь-яке твоє вміння та залучення стає частиною великої справи — збереження України! Не обов'язково мати мільйони — достатньо бажання та готовності діяти!",
  },
];

function transformHowToHelpData(data: HowToHelp[]): HowToHelpFormatted[] {
  return data.map((item) => {
    const words = item.heading.split(' ');
    const firstWord = words[0] || '';
    const restOfHeading = words.slice(1).join(' ');
    
    return {
      firstWord,
      heading: restOfHeading,
      description: item.text,
    };
  });
}

export async function loadHowToHelp() {
  try {
    // Call the API to get all how-to-help entries
    const response = await howToHelpService.getAll();
    
    // Extract the data from the response
    const newHowToHelpList: HowToHelp[] = response.data;
    
    // Transform and sort by id before returning
    if (newHowToHelpList && newHowToHelpList.length > 0) {
      const sortedData = newHowToHelpList.sort((a, b) => a.id - b.id);
      howToHelpList = transformHowToHelpData(sortedData);
    }
  } catch (error) {
    console.error("Failed to load how-to-help data:", error);
    throw new Error("Не вдалося завантажити дані про допомогу");
  }
}

export function getHowToHelp() {
  return howToHelpList;
}